<template>
  <q-dialog
    class="ws-modal"
    v-bind="attrs"
    :value="value"
    square
    v-on="$listeners"
  >
    <div class="ws-modal-inner">
      <slot name="header">
        <div
          v-if="cfg.title"
          class="header row"
        >
          <h5>{{ $t(cfg.title) }}</h5>
          <ws-button
            type="secondary-inverse"
            size="small"
            icon="close"
            class="close"
            @click="$emit('input', false)"
          />
        </div>
      </slot>
      <slot></slot>
    </div>
  </q-dialog>
</template>

<script lang="ts">
import {QDialog} from 'quasar';
import {computed, defineComponent} from 'vue';
import { WsButton } from '@odin/components-vue2';

export default defineComponent({
  name: 'WsModal',
  components: {
    WsButton,
    QDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    cfg: {
      type: Object,
      default: () => ({
        title: '',
      }),
    },
  },
  defineEmits: ['input'],
  setup(props, vm) {
    const attrs = computed(() => {
      const contentClass = vm.attrs['content-class']
        ? ` ${vm.attrs['content-class']}`
        : '';
      return {
        ...vm.attrs,
        ['content-class']: `wsk-root wsk-app${contentClass}`,
      };
    });

    return {attrs};
  }
});
</script>

<style lang="scss" scoped>
.ws-modal-inner {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
  background: $ws-white;
  overflow: visible;

  > .header {
    padding: 24px 32px;

    > h3 {
      margin-bottom: 0;
    }

    ::v-deep {
      > .close {
        position: absolute;
        right: 22.4px;
        top: 22px;
        color: $ws-base100;
      }
    }
  }
}
</style>
